/* eslint-disable import/first */
import React from 'react';
// import css from './index.module.scss';
// eslint:fix css is defined but never used

export default function ProductName({ productName, className }) {
  return <h3 className={className || ''} data-title={productName}>{productName}</h3>;
}
